import {createQueryKeys} from "@lukemorales/query-key-factory";
import {GetGtaRateListRequest, GetGtaRateRequest} from "@/Stub/V1";

export const GtaRates = createQueryKeys('gtaRates', {
    list: (requestParams?: GetGtaRateListRequest) => [{requestParams}],
    detail: (requestParams?: GetGtaRateRequest) => [{requestParams}],
    config: () => ['gta-config'],
});
